import React, { useEffect, useState } from "react";
import { observer } from "mobx-react-lite";
import { reaction } from "mobx";
import { Clip } from "../Clip/Clip";
import { CompositionStateStore } from "../../../../store/CompositionStateStore";

interface PlaceholderClipProps {
    clipId: string;
    layerId: string;
}

export const PlaceholderTimelineClip: React.FC<PlaceholderClipProps> = observer(({ clipId, layerId }) => {
    const [filename, setFilename] = useState<string | undefined>(CompositionStateStore.getClipTitle(clipId));

    useEffect(() => {
        const disposer = reaction(
            () => ({
                filename: CompositionStateStore.getClipTitle(clipId),
            }),
            ({ filename }) => {
                setFilename(filename);
            },
            { fireImmediately: true },
        );

        return () => {
            disposer();
        };
    }, [clipId]);

    return (
        <Clip
            clipId={clipId}
            layerId={layerId}
            filename={filename ?? "Placeholder"}
            backgroundColor={"156, 163, 175"} // gray-400
            showAudioTransitions={false}
            showVisualTransitions={false}
        >
            <svg width="12" height="12" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M12 5V19"
                    stroke="white"
                    strokeWidth="2"
                    strokeLinecap="round"
                />
                <path
                    d="M5 12H19"
                    stroke="white"
                    strokeWidth="2"
                    strokeLinecap="round"
                />
            </svg>
        </Clip>
    );
});

